module.exports = __webpack_public_path__ + "img/1.796f7487.jpg";